import React, { useState, useEffect } from "react";
import { Link } from "gatsby"
import { Container, Row, Col, Breadcrumb } from "react-bootstrap"
import dateformat from "dateformat"
import _ from "lodash"

import Layout from "../components/layout";
import Connect from "../components/PropertyDetails/Connect/Connect";
import AuctionCard from "../components/Auctions/PastAuctionCard"
import { CustomLinks } from "../components/common/utils"
import SEO from "../components/seo";
import Counter from '../components/Home/Counter/Counter.js'

const PastAuctionsDetails = (props) => {
    const { properties = [], auctionArticle, auctionId } = props.pageContext;

    const article_page = auctionArticle || null;
    const counter_module = article_page?.Modules?.filter(m => m.__typename === "ComponentComponentBannerBottom");

    const [sortedProperties, setSortedProperties] = useState([]);

    useEffect(() => {
        if (properties.length > 0) {
            setSortedProperties(_.orderBy(properties, ['alt_lot_number', 'extra.lotNumber'], ['asc', 'asc']));
        }
    }, [properties]);

    return (
        <Layout GQLPage="" Layout="Without_Banner" classNames={"search-header person-header details-header"} popular_search_slug={"auctions"}>

            <SEO title={"Past Auction Details"} description={"Past Auction Details"} />

            {counter_module?.length > 0 && counter_module.map((Module, i) => (
                <Counter key={i} Module={Module} Layout={article_page.Layout} />
            ))}

            <section className="property-nav sample">
                <Container>
                    <Row>
                        <Col>
                            <div className="breadcrumb d-none d-lg-flex">
                                <Breadcrumb>
                                    <li className="breadcrumb-item"><Link to='/'>Home</Link></li>
                                    <li className="breadcrumb-item"><Link to={"/auctions/"}>auctions</Link></li>
                                    <li className="breadcrumb-item"><Link to={"/auctions/past-auctions/"}>Past auctions</Link></li>
                                    <li className="breadcrumb-item active"><a>Past Auction details</a></li>
                                </Breadcrumb>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="pt-5 feature-section auction-details">
                <Container>
                    <Row>
                        <Col>
                            <h1 className="mb-2">Past Auctions - {sortedProperties.length > 0 ? dateformat(sortedProperties[0]?.auctionDate, 'dddd, d mmmm yyyy') : "No"}</h1>
                        </Col>
                    </Row>

                    <Row className="auction-row mt-5">
                        {sortedProperties.map((propertyItem) => {
                            if (!propertyItem?.display_address) return null;
                            const department_path = propertyItem?.department === "auction_residential"
                                ? "/auction-residential-property-for-sale"
                                : "/auction-commercial-property-for-sale";
                            const uriStr = department_path + "/" + propertyItem?.slug + "-" + propertyItem?.id;
                            return (
                                <Col key={propertyItem.id} lg={4} xl={3} md={6} className="mb-5 auction_item">
                                    <AuctionCard
                                        propertyImages={propertyItem?.images}
                                        Offer={propertyItem?.status}
                                        propertyPrice={propertyItem?.price}
                                        propertyTitle={propertyItem?.title}
                                        propertyDisplayAddress={propertyItem?.display_address}
                                        propertyNegoId={propertyItem?.crm_negotiator_id}
                                        auctionUrl={uriStr}
                                        lotNumber={propertyItem?.extra?.lotNumber}
                                        building={propertyItem?.building}
                                        extra={propertyItem?.extra}
                                        page_url={CustomLinks.past_auction_details + auctionId}
                                    />
                                </Col>
                            );
                        })}
                    </Row>
                </Container>
            </section>

            <Connect department="auctions" />
        </Layout>
    );
}

export default PastAuctionsDetails;
